// https://nextjs.org/docs/app/building-your-application/routing/error-handling
'use client';

import pridebot from 'images/bots/pridebot.svg';
import BotImage from '../../components/botimage';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div>
      <h2>Something went wrong!</h2>
      <button type="button" onClick={() => reset()}>
        Try again
      </button>

      <p>{error.message}</p>

      <BotImage src={pridebot} />
    </div>
  );
}
